import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { LumberList } from '@paragon/contract-library';

import { MaterialListsSliceState } from '../store/materialListsSlice';
import { getLoggedInUsersOrganizationMaterialSet } from './getLoggedInUsersOrganizationMaterialSetSelector';

export const getLumberLists = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  (materialSet) => materialSet?.lumberLists,
);

export function useLumberList(lumberListGuid: string | undefined): LumberList | 'loading' | null {
  const materialListStatus = useSelector((state: MaterialListsSliceState) => state.materialLists.state);
  const lumberLists = useSelector(getLumberLists);

  if (materialListStatus !== 'loaded') return 'loading';

  return lumberListGuid ? (lumberLists ?? {})[lumberListGuid] : null;
}
